module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.5e809c17f25d1cf3fb68.svg";


//////////////////
// WEBPACK FOOTER
// D:/TELEMED-FINAL/telemed/node_modules/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.svg
// module id = ../../../../primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.svg
// module chunks = styles